<template>
	<div
		v-if="isLoading"
		class="relative mb-1"
	>
		<FormulateInput
			v-model="values.clubs[0].alumni_clubs"
			:input-name-selected-text="context.attributes['input-name-selected-text']"
			type="CustomSearchSelect"
			name="alumni_clubs"
			:options="clubsList"
			placeholder="Выберите значение"
			class="user-profile-field mb-0"
			@search="getClubs($event)"
		/>
	</div>
</template>

<script>

export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			values: {
				clubs: [{}],
			},
			requestValues: [
				'alumni_clubs',
			],
			autocompleteGroupValues: [
				'alumni_clubs',
			],
			clubsList: [],
			isLoading: false,
		};
	},
	watch: {
		'values.clubs': {
			handler() {
				this.$emit('setValues', 'clubs', this.values.clubs);
			},
			deep: true,
		},
	},
	async created() {
		await this.getClubs('');
		this.autocomplete();
	},
	methods: {
		async getClubs(search) {
			const {data: clubs} = await this.$api.getClubs(search);
			this.clubsList = clubs;
		},
		async autocomplete() {
			try {
				const qs = `${this.requestValues
					.map((key) => `slugs[]=${encodeURIComponent(key)}`)
					.join('&')}`;

				const {data: values} = await this.$api.getUserProfileFields(qs);

				if (!this.values.clubs) {
					this.values.clubs = [];
				}

				this.autocompleteGroupValues.forEach((key) => {
					if (values[key]) {
						values[key].forEach((value, index) => {
							if (!this.values.clubs[index]) {
								this.values.clubs.push({});
							}
							const club = this.values.clubs[index];
							club[key] = value;
						});
					}
				});

				this.$emit('setValues', 'clubs', this.values.clubs);
			} catch (error) {
				console.log(error);
			}

			this.isLoading = true;
		},
	},
};
</script>
